import { Button, Dropdown, Typography } from "@plum-xoxo/admin-dsm";
import React, { useEffect, useState } from "react";

import styled from "styled-components";
import { makeRequestAuth } from "../../../utils/globals";
import { NotificationManager } from "react-notifications";

const StyledDropdown = styled(Dropdown).attrs()`
  .eui-dd-control {
    padding: 9px 0px;
  }
`;

const employeeNumberOptions = [
  { label: "0 - 50", value: "0 - 50" },
  { label: "51 - 200", value: "51 - 200" },
  { label: "201 - 500", value: "201 - 500" },
  { label: "501 - 1,000", value: "501 - 1000" },
  { label: "1,001 - 5,000", value: "1001 - 5000" },
  { label: "5,001 - 10,000", value: "5001 - 10000" },
  { label: "10,001+", value: "10001+" },
];

const Regions = [
  { label: "India", value: "India" },
  { label: "Americas", value: "Americas" },
  { label: "UK & Europe", value: "UK & Europe" },
  { label: "GCC and Turkey", value: "GCC and Turkey" },
  { label: "Africa", value: "Africa" },
  { label: "KSA & LENA", value: "KSA & LENA" },
  { label: "Rest APAC", value: "Rest APAC" },
  { label: "Rest of World", value: "Rest of World" },
];

const LastStep = ({
  UID,
  setCurrentStep,
  noOfEmployees,
  setNoOfEmployees,
  region,
  setRegion,
  password,
  email,
}) => {
  const [disabled, setDisabled] = useState(false);
  const [loader, setLoader] = useState(false);

  const validateDetails = () => {
    if (!noOfEmployees?.value || !region?.value || disabled || loader) return;

    setLoader(true);

    const UpdatePasswordPromise = new Promise((resolve, reject) => {
      const query = "diy.mutation.add_password_v2";
      const requestData = {
        query,
        tag: "diy",
        variables: {
          pwd: password,
          diy_uuid: UID,
          email,
          noOfEmployees: noOfEmployees?.value,
          region: region?.value,
        },
      };

      makeRequestAuth(
        requestData,
        (response) => {
          if (response) {
            resolve(response);
          } else {
            reject(0);
          }
        },
        {},
        "/api/public/graph"
      );
    });

    UpdatePasswordPromise.then((response) => {
      const data = response?.data?.addPasswordV2;
      if (data.success === 1) {
        setCurrentStep(4);
      } else {
        NotificationManager.error("Something went wrong");
      }
      setLoader(false);
    }).catch((e) => {
      setLoader(false);
      NotificationManager.error("Something went wrong");
    });
  };

  useEffect(() => {
    if (disabled && noOfEmployees?.value && region?.value) setDisabled(false);
  }, []);

  return (
    <div className="d-flex flex-column gap-16 w-100">
      <div>
        <Typography.BodySmall className="mb-4">
          Step 3 of 3
        </Typography.BodySmall>
        <Typography.H1 className="mb-4">One last step!</Typography.H1>
        <Typography.BodySmall>
          Help us get to know your organisation better.
        </Typography.BodySmall>
      </div>
      <StyledDropdown
        className="mb-4"
        isSearchable={false}
        options={employeeNumberOptions}
        placeholder="Select number of employees"
        value={noOfEmployees}
        onChange={(value) => setNoOfEmployees(value)}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        menuPosition={"fixed"}
      />
      <StyledDropdown
        className="mb-4"
        options={Regions}
        placeholder="Select your region"
        value={region}
        onChange={(value) => setRegion(value)}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        menuPosition={"fixed"}
        onKeyDown={(e) => {
          if (e.key === "Enter") validateDetails();
        }}
      />

      <Button
        loading={loader}
        disabled={!noOfEmployees?.value || !region?.value || disabled || loader}
        size={"large"}
        className="mt-12"
        onClick={validateDetails}
        isLoading={loader}
      >
        Create Account
      </Button>
    </div>
  );
};

export default LastStep;
